define('app-SearchResults/modules/batBelt/settings',[],function () {
    return {
        container: '.searchBatBelt',
        searchPageUrl: '/search'
    };
});
